import { configureStore } from '@reduxjs/toolkit';
import coordinatorReducer from './slices/coordinatorSlices';

export const store = configureStore({
  reducer: {
    coordinator: coordinatorReducer,
  },
});
